import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

import { formatNull } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';

import styles from '../../styles/DynamicModal.module.css';
import stylesSearch from '../../styles/Search.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const SearchDebtors = ({ closeModal }) => {
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    const inputRef = React.useRef(null);
    
    React.useEffect(() => {
        inputRef.current?.focus();
    }, []);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500); // задержка 500 мс

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (debouncedSearchTerm.trim() == '') {
            setWarning('Введите поисковый запрос');
        } else {
            setLoading(true);

            axios.get(`/api/search-debtors?searchterm=${debouncedSearchTerm}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                if (response.data.length === 0) {
                    setUsers([]);
                    setWarning('Ничего не найдено');
                } else {
                    setUsers(response.data);
                    setWarning('');
                }
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }, [debouncedSearchTerm]);


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Поиск по должникам</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main} style={{height: '80vh'}}>
                    <div className={stylesSearch.searchInputWrapper}>
                        <input type='text' value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='ФИО, наименование, адрес, ИНН, ОГРНИП, ОГРН, СНИЛС или место рождения...' ref={inputRef} />
                    </div>
                    <div className={stylesSearch.mainWrapper}>
                        {loading ? <LoadingLines />
                        : warning ? <a className={`description ${stylesSearch.centerWarning}`}>{warning}</a>
                        : <>
                            <a className='description'>Первые 20 совпадений</a>
                            <div
                                className='tableRow nonActive' 
                                style={{gridTemplateColumns: '25fr 40fr 15fr 15fr'}} 
                            >
                                <div>
                                    ФИО или наименование
                                </div>
                                <div>
                                    Адрес
                                </div>
                                <div>
                                    ИНН
                                </div>
                                <div>
                                    ОГРН(ИП)
                                </div>
                            </div>
                            {users.map(caseItem => (
                                <motion.div
                                    className='tableRow' 
                                    style={{gridTemplateColumns: '25fr 40fr 15fr 15fr'}} 
                                    onClick={(e) => {e.preventDefault(); window.open(`/debtor/${caseItem.id}`, '_blank')}}
                                    key={caseItem.id}
                                    initial={{ scale: '97%', opacity: 0 }}
                                    animate={{ scale: '100%', opacity: 1 }}
                                    exit={{ scale: '97%', opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    layout
                                >
                                    <div>{caseItem.name}</div>
                                    <div>{formatNull(caseItem.postal_address)}</div>
                                    <div>
                                        {formatNull(caseItem.TIN)}
                                    </div>
                                    <div>{formatNull(caseItem.OGRN)}</div>
                                </motion.div>
                            ))}
                        </>
                        }
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default SearchDebtors;
